import React from "react";
import { loaderGif } from "./assets/images";

const Loading = () => {
  return (
    <div className="fixed inset-0  flex font-sora justify-center items-center  bg-white dark:bg-black dark:bg-opacity-80  bg-opacity-70 backdrop-blur-sm">
      <div className="w-[120px] h-[120px]">
        <img src={loaderGif} alt="" className="w-full h-full object-contain" />
      </div>
    </div>
  );
};

export default Loading;
